import { Controller } from "stimulus"

export default class MaterializeController extends Controller {
  initialize() {
    const target = this.element
    const observer = new MutationObserver((mutations) => {
      observer.disconnect()
      Promise.resolve().then(start)
      M.updateTextFields();
    })
    function start() {
      observer.observe(target, { childList: true, subtree: true })
    }
    start()
  }
}
